import { fromJS } from 'immutable';

import {
  SET_SIGNUP_PREFILLED,
  SET_LOGIN_PREFILLED,
  CLEAR_INVITE_PREFILLED,
  LOAD_CAMPAIGN_INVITE_ERROR,
  LOAD_CAMPAIGN_INVITE,
} from './constants';

const initialState = fromJS({
  shortId: null,
  name: null,
  email: null,
  error: null,
  loading: true,
});

function campaignInviteReducer(state = initialState, action) {
  switch (action.type) {
  case SET_SIGNUP_PREFILLED:
    return state
      .set('shortId', action.shortId)
      .set('name', action.name)
      .set('email', action.email);
  case SET_LOGIN_PREFILLED:
    return state
      .set('email', action.email);
  case LOAD_CAMPAIGN_INVITE:
    return state
      .set('loading', true)
      .set('error', null);
  case LOAD_CAMPAIGN_INVITE_ERROR:
    return state
      .set('loading', false)
      .set('error', action.error);
  case CLEAR_INVITE_PREFILLED:
    return initialState;
  default:
    return state;
  }
}

export default campaignInviteReducer;



/** WEBPACK FOOTER **
 ** ./src/containers/campaign-invite/reducer.js
 **/